'use client';

import * as LabelPrimitive from '@radix-ui/react-label';
import type * as React from 'react';

import { cn } from '@/lib/utils';

function Label({ className, ...props }: React.ComponentProps<typeof LabelPrimitive.Root>) {
  return (
    <LabelPrimitive.Root
      data-slot="label"
      className={cn(
        'text-fg-2 flex items-center gap-1.5 text-xs font-medium select-none',
        className,
      )}
      {...props}
    />
  );
}

export { Label };
